import { EventBroker } from './eventbroker';
import { loginUrlForMapCase, logoutUrl, accountUrl } from './connection_utils';
import { App } from './BMapsApp';
import { openHelpMenu } from './ui/HelpPanel';
import { openCommandPanel } from './ui/CommandPanel';
import { showAbout } from './ui/AboutContent';

// menucmds.js

// Menu commands

// function MenuHowTo () {
//     console.log("How-to menu invoked.");
//     window.open("https://dev-server.boltzmannmaps.com/bmaps-wiki/index.php/How_To_...");
// }

// function MenuFAQ () {
//     console.log("FAQ menu invoked.");
//     window.open("https://dev-server.boltzmannmaps.com/bmaps-wiki/index.php/FAQ");
// }

// function MenuEditConfig () {
//     console.log("Configure menu invoked.");
//     dialogAlert('Configure', 'Not yet implemented.');
// }

function MenuTutorials() {
    window.open('https://www.youtube.com/channel/UCoFsnMxpCs1NnTB-9JAb1fw?&ab_channel=ConiferPoint');
}

function MenuRlbReactions() {
    window.open('https://rlb.boltzmannmaps.com/services/rxns/', '_blank', 'noopener');
}

function MenuAbout() {
    showAbout();
}

function MenuAccount() {
    window.location.href = accountUrl();
}

function MenuLogout() {
    if ($('#LogoutMenuItem').text() === 'Logout') {
        window.location.href = logoutUrl();
    } else {
        window.location.href = loginUrlForMapCase(App.Workspace.getLoadedProtein());
    }
}

const mainMenuItems = [
    // {id: 'SelectStructure', label: 'Select Protein', handler: MenuSelectStructure},
    // {id: 'HowTo', label: 'How To ...', handler: MenuHowTo},
    // {id: 'FAQ', label: 'FAQ', handler: MenuFAQ},
    // {id: 'EditConfig', label: 'Configure', handler: MenuEditConfig},
    { id: 'About', label: 'About', handler: MenuAbout },
    // { id: 'Tutorials', label: 'Tutorials', handler: MenuTutorials },
    { id: 'Help', label: 'Need Help?', handler: openHelpMenu },
    { id: 'RlbReactions', label: 'RLB Reactions', handler: MenuRlbReactions },
    { id: 'Account', label: 'Account', handler: MenuAccount },
    { id: 'Logout', label: 'Logout', handler: MenuLogout },
];

export function initMenus() {
    for (const menuItem of mainMenuItems) {
        addMenuItem(menuItem.id, menuItem.label, menuItem.handler);
    }
    $('#topbar-menu-button').click(toggleMainMenu);

    // Close at appropriate times.
    // Note that backgroundMouse is only invoked if something has been loaded
    EventBroker.subscribe('backgroundMouse', closeMainMenu);
    EventBroker.subscribe('escapeKey', closeMainMenu);

    EventBroker.subscribe('connectionStatusChanged', (_, { connected, mode }) => {
        if (mode === 'static') {
            $('#LogoutMenuItem').text('Login / Sign Up');
            $('#AccountMenuItem').parent().hide();
        } else {
            $('#LogoutMenuItem').text('Logout');
            $('#AccountMenuItem').parent().show();
        }
    });
}

export function addMenuItem(id, label, handler) {
    const mainMenu = $('#topbar-menu-list');

    const menuid = `${id}MenuItem`;
    const buttonid = `${id}button`;
    const itemText = label;
    mainMenu.append(`<li id='${buttonid}'><a id='${menuid}'>${itemText}</a></li>`);
    $(`#${buttonid}`).click(() => { toggleMainMenu(); handler(); });
}

function toggleMainMenu() {
    $('#topbar-menu-list, #topbar-menu-button').toggleClass('open');
}

function closeMainMenu() {
    $('#topbar-menu-list, #topbar-menu-button').removeClass('open');
}
